import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { mutate } from "swr"

import { PriceDropAlertRequest } from "commonModule/services/priceDropAlert"
import { apiClientCommon } from "services/apiClientCommon"
import { RootState } from "stores/store"

import { PriceDropInitialState } from "./types"

export const createUpdatePriceDropAlert = createAsyncThunk(
  "/user/price-drop-alert",
  async (request: PriceDropAlertRequest) => {
    const response = await apiClientCommon.createUpdatePriceDropAlert(request)
    // get the updated fav. list & fav. properties ids
    void mutate("/user/favouritelist/all-properties-by-userid")
    void mutate(`/api/getFavoritePropertyIds`)
    return response.data
  },
)

export const initialState: PriceDropInitialState = {
  error: null,
  isLoading: false,
  switchPriceDrop: false,
  isPriceDropId: null,
}

export const priceDropSlice = createSlice({
  name: "priceDrop",
  initialState,
  reducers: {
    setSwitchPriceDrop: (state, action: PayloadAction<boolean>) => {
      state.switchPriceDrop = action.payload
    },
    setPriceDropId: (state, action: PayloadAction<string | null>) => {
      state.isPriceDropId = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createUpdatePriceDropAlert.pending, (state) => {
      state.isLoading = true
      state.error = null
      state.isPriceDropId = null
    })
    builder.addCase(createUpdatePriceDropAlert.fulfilled, (state, action) => {
      state.isPriceDropId = action.payload.data
    })
    builder.addCase(createUpdatePriceDropAlert.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.error.message || "price drop alert Error"
      state.isPriceDropId = null
    })
  },
})

export const { setSwitchPriceDrop, setPriceDropId } = priceDropSlice.actions

export const selectSwitchPriceDrop = (state: RootState) =>
  state.priceDropReducer.switchPriceDrop
export const selectPriceDropId = (state: RootState) =>
  state.priceDropReducer.isPriceDropId

export default priceDropSlice.reducer
